import { combineReducers } from 'redux';
import {
    REQUEST_SEARCH,
    RECEIVE_SEARCH,
    RECEIVE_SEARCH_UPDATE,
    SEARCH_PAGE_COUNT,
    SEARCH_CONTEXT_UNSET,
    SET_SEARCH_CONTEXT,
} from './actionTypes';
import { mergeObjectArrays } from '../../configureStore';
import config from '../../config/config';

const SEARCH_CONTEXT_DEFAULT = config.DEFAULT_SEARCH_IN;

const items = (state = [], action) => {
    switch (action.type) {
        case REQUEST_SEARCH:
            return state;
        case RECEIVE_SEARCH:
            if (action.page === 1) return action.items;
            else return mergeObjectArrays(action.items, state);
        case RECEIVE_SEARCH_UPDATE:
            return mergeObjectArrays(action.items, state);
        default:
            return state;
    }
};

const isFetching = (state = { fetching: false, page: 1 }, action) => {
    switch (action.type) {
        case REQUEST_SEARCH:
            return { fetching: true, page: action.page };
        case RECEIVE_SEARCH:
        case RECEIVE_SEARCH_UPDATE:
            return { ...state, fetching: false };
        default:
            return state;
    }
};

const hasMore = (state = false, action) => {
    switch (action.type) {
        case REQUEST_SEARCH:
            return true;
        case RECEIVE_SEARCH:
            return action.items.length >= SEARCH_PAGE_COUNT;
        default:
            return state;
    }
};

const fromContext = (state = SEARCH_CONTEXT_UNSET, action) => {
    switch (action.type) {
        case REQUEST_SEARCH:
        case RECEIVE_SEARCH:
            return action.context;
        default:
            return state;
    }
};

const toContext = (state = SEARCH_CONTEXT_DEFAULT, action) => {
    switch (action.type) {
        case SET_SEARCH_CONTEXT:
            return action.value;
        default:
            return state;
    }
};

export const searchReducer = combineReducers({
    items,
    isFetching,
    hasMore,
    fromContext,
    toContext,
});
